import { Components } from '@mui/material';
import { Theme } from '@mui/material/styles';

export const MuiChip: Components<Theme>['MuiChip'] = {
  styleOverrides: {
    root: ({ ownerState, theme }) => ({
      borderRadius: 8,
      ...theme.typography.label2,
      ...(ownerState.color === 'default' && {
        backgroundColor: theme.palette.primary.lighter,
      }),
    }),
    label: {
      padding: '0 12px',
    },
  },
};
